import React, {useCallback, useEffect, useRef, useState} from 'react';

import {faCaretUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ApiRoute from "../../helper/api";

export default function DriverSelect ({ assignItem, absoluteSelectedStyle= false, multiple = true, customDefaultValue = false, defaultValue = [], placeholder = 'انتخاب راننده' , fixed = false }) {

    const [show,setShow] = useState(false)
    const [term,setTerm] = useState('')
    const [selected,setSelected] = useState([])
    const [data,setData] = useState(null)
    const [updateData,setUpdateData] = useState('1')
    const wrapperRef = useRef(null)
    const [menuStyle,setMenuStyle] = useState(null)

    const updateMenuPosition = useCallback(() => {
        if (!wrapperRef.current) {
            return
        }

        const shouldUseFixedMenu = fixed || window.innerWidth < 1024

        if (!shouldUseFixedMenu) {
            setMenuStyle(null)
            return
        }

        const rect = wrapperRef.current.getBoundingClientRect()
        const viewportPadding = 12

        setMenuStyle({
            top: `${rect.bottom + 4}px`,
            left: `${Math.max(viewportPadding, rect.left)}px`,
            width: `${Math.min(rect.width, window.innerWidth - (viewportPadding * 2))}px`
        })
    }, [fixed])

    useEffect(() => {
        syncDefaultValue()
    }, [defaultValue]);

    useEffect(() => {
        assignItem(selected)
    }, [selected]);

    useEffect(() => {
        if (defaultValue.length > 0) {
            setSelected([])
        }
    }, [updateData]);

    useEffect(() => {
        if (!show) {
            return
        }

        updateMenuPosition()
        window.addEventListener('resize', updateMenuPosition)
        window.addEventListener('scroll', updateMenuPosition, true)

        return () => {
            window.removeEventListener('resize', updateMenuPosition)
            window.removeEventListener('scroll', updateMenuPosition, true)
        }
    }, [show, updateMenuPosition]);


    const syncDefaultValue = async () => {
        if (defaultValue.length > 0){
            if (customDefaultValue){
                setSelected(defaultValue)
            }else {
                try {
                    const res = await ApiRoute.shipment.logico.getBySlugs.fn(defaultValue)
                    setSelected(res.results)
                }catch (e) {
                    console.log(e)
                }
            }

        }else{
            setUpdateData(Date.now().toString())
        }

    }

    const getCategory = async (searchTerm = term) => {
        const res = await ApiRoute.shipment.logico.index.fn({
            title: searchTerm
        })
        setData(res.results.data)
    }

    function has(item){
        for (const selectedElement of selected) {
            if (selectedElement._id === item._id){ return true }
        }
        return false
    }

    async function openMenu(){
        const nextShow = !show
        setShow(nextShow)
        if (nextShow) {
            updateMenuPosition()
        }
        if (data == null){
            await getCategory()
        }
    }

    async function showMenu(){
        setShow(true)
        updateMenuPosition()
        if (data == null){
            await getCategory()
        }
    }

    return (
        <div ref={wrapperRef} className={"relative w-full"}>
            <div className={`flex items-center justify-between w-full overflow-hidden rounded border border-gray-3 bg-gray-1 focus-within:border-purple-4`}>
                <input
                    onChange={ async (e) => {
                        const value = e.target.value
                        setShow(true)
                        setTerm(value)
                        await getCategory(value)
                    } }
                    onFocus={showMenu}
                    className="input-x !m-0 h-10 min-w-0 w-full !border-0 bg-gray-1 focus:outline-none"
                    placeholder={placeholder}
                    type={"search"}/>
                <button type="button" onClick={openMenu} className={`flex h-10 w-10 shrink-0 items-center justify-center bg-gray-4 text-white`}>
                    <FontAwesomeIcon className={`text-lg text-white transition ${show ? '' : 'rotate-180'}`}
                                     icon={faCaretUp}/>
                </button>
            </div>
            {(show && data) && <div
                style={menuStyle || undefined}
                className={`${fixed ? 'fixed' : 'absolute max-lg:fixed'} text-13 overflow-auto max-h-[250px] z-[9999] w-full flex flex-col gap-1 bg-white border border-gray-3 rounded shadow-box p-2`}>
                {data.map((item) => <div key={item._id}
                                         onClick={ () => {
                                             if (!has(item)){
                                                 if (multiple){
                                                     setSelected(selected => [...selected, item])
                                                 }else{
                                                     setSelected([item])
                                                 }

                                             }
                                             setShow(false)
                                         }}
                                         className={"cursor-pointer rounded px-2 py-2 hover:bg-gray-8 hover:text-blue-1"}>{item.name}</div>)}
            </div>}

            {selected?.length > 0 && <div className={(absoluteSelectedStyle ? 'absolute' : '')+` flex p-2 flex-wrap gap-2 mt-1`}>
            {selected.map((item) => <div onClick={ () => {
                setShow(false)
                setSelected(selected.filter(xitem => xitem._id !== item._id))
            } } className={`text-[11px] flex cursor-pointer justify-between bg-green-2 hover:bg-red-1 text-white rounded px-2`} key={item._id}>
                <div>{item.name}</div>
            </div>)}
        </div>}
        </div>

        /*<Select
            //onMenuOpen={ async () => { alert(1) } }
            options={options}
            isMulti={true} // Enable multi-select
            value={values}
            onChange={onChange}
            styles={customStyles}
            placeholder={placeholder}
        />*/
    );
};
